import { SET_ALERT_ERROR, SET_ALERT_SUCCESS, RESET_ALERT } from '../../constants/actionTypes';

const initialState = {
    "error": null,
    "success": null,
};

const pageAlertReducer = (state = initialState, action) => {
    switch(action.type) {
        case SET_ALERT_ERROR:
            return {
                "error": action.payload,
                "success": null,
            };
        case SET_ALERT_SUCCESS:
            return {
                "error": null,
                "success": action.payload,
            };
        case RESET_ALERT:
            return {
                "error": null,
                "success": null,
            };
        default:
            return state;
    }
};

export default pageAlertReducer;